export enum UserTask {
  Error = -1,
  Unknown = 0,
  Register = 1,
  Start = 2,
  Done = 3
}
